import { render, staticRenderFns } from "./PagesHeader.vue?vue&type=template&id=beacdac6&"
import script from "./PagesHeader.vue?vue&type=script&lang=js&"
export * from "./PagesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports